import React from 'react'
import BtnPrimary from 'components/generic/BtnPrimary'
import InfoBox from 'components/generic/InfoBox'
import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectUserIsLoggedIn } from 'redux/selectors'
import styles from './combinedRatingFilter.module.scss'

const GameZoneModalContent = ({ registerUrl }: { registerUrl: string }) => {
  const isLoggedIn = useSelector(selectUserIsLoggedIn)

  return (
    <>
      {!isLoggedIn && (
        <InfoBox className={styles.infoBox} textOnly>
          <Trans ns='strFilters' i18nKey='gameZoneModal.register.info'>
            <b>This feature is available to registered users only.</b>
          </Trans>

          <Trans ns='strFilters' i18nKey='gameZoneModal.register.button'>
            <BtnPrimary href={registerUrl} className={styles.registerBtn} size='small'>
              register now
            </BtnPrimary>
          </Trans>
        </InfoBox>
      )}
      <section className={styles.content}>
        <Trans ns='strFilters' i18nKey='gameZoneModal.content'>
          <b>
            Our Game zONe identifies a range of potential opponents whose Numbers are close to yours
            on the scale.
          </b>
          <ul>
            <li>
              Game zONe will find evenly-matched opponents wherever you are, to ensure the best
              possible experience on court
            </li>
            <li>
              Our industry-leading algorithm analyses player performance data and millions of match
              results.
            </li>
          </ul>
          <p>
            Don’t forget, as your Number changes, your Game zONe will change too, so be sure to
            check back regularly to find new opponents to play.
          </p>
        </Trans>
      </section>
    </>
  )
}

export default GameZoneModalContent
